module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAZCAMAAAAGyf7hAAAAXVBMVEVHcEwAuXAAw30Ay4cAy4YA0IgAzYkAwnwAwXoAwXoAxoEAvXYAy4cAw30AwHkAyYQBxoEAunMAuXD///8jy4+G4sGr69Tz/Pk90JrM8+VL1qRo27Hf9+/I8uJa2ax+RMooAAAAC3RSTlMA6DHOtxDfgJRkWQqPEDcAAAC/SURBVCjPbZDbEoMgDAWx1aqFCDSA1/b/P7MBtEA1w9POnjkhjPVdmieL07605nwYBgBQqo2wKqDqAiRGkB9Q1gEeZqRS1s3ZlOLeXEDx2OOxKUCi0Rzs4k1jjWcimNogTgBiw2U3Q9zhpsDhnMe52tCuOBqV4tQzIY74KYqIOkS3r/SDZkSfLuNvnOmVcUsayTY3qWYFWGnbbE+Lzv/IoU1xDRN4KBdRFKV75ntmpxOsurpnf75nz9it/Zsb+wJ7oxutsDIchQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/online_service/xls.png
// module id = AFDT
// module chunks = 1